__turbopack_context__.v({
  "container": "ItineraryCardTrainTimes-module__wo8iYq__container",
  "date": "ItineraryCardTrainTimes-module__wo8iYq__date",
  "dateEnd": "ItineraryCardTrainTimes-module__wo8iYq__dateEnd",
  "dateRow": "ItineraryCardTrainTimes-module__wo8iYq__dateRow",
  "dateStart": "ItineraryCardTrainTimes-module__wo8iYq__dateStart",
  "duration": "ItineraryCardTrainTimes-module__wo8iYq__duration",
  "station": "ItineraryCardTrainTimes-module__wo8iYq__station",
  "stationEnd": "ItineraryCardTrainTimes-module__wo8iYq__stationEnd",
  "stationLabel": "ItineraryCardTrainTimes-module__wo8iYq__stationLabel",
  "stationTooltip": "ItineraryCardTrainTimes-module__wo8iYq__stationTooltip",
  "stations": "ItineraryCardTrainTimes-module__wo8iYq__stations",
  "time": "ItineraryCardTrainTimes-module__wo8iYq__time",
  "timeLine": "ItineraryCardTrainTimes-module__wo8iYq__timeLine",
  "times": "ItineraryCardTrainTimes-module__wo8iYq__times",
});
